module.exports = __webpack_public_path__ + "static/img/Mark-Korda.e17c001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark-Korda.jpg
// module id = xEXK
// module chunks = 1